import * as React from 'react';
import {
  Create,
  SimpleForm,
  TextField,
  ReferenceField,
  CheckboxGroupInput,
  required,
  NumberInput,
} from 'react-admin';
import {makeStyles} from '@material-ui/core/styles';
import TimeInput from '../components/TimeInput';

export const styles = {
  inline: {display: 'inline-block', marginLeft: 32},
  margin: {marginLeft: 32, marginRight: 32},
};

const useStyles = makeStyles(styles);

const redirect = (basePath, id, data) => `/courts/${data.courtId}/prices`;

const PriceCreate = (props) => {
  const classes = useStyles();
  return (
    <Create {...props}>
      <SimpleForm redirect={redirect}>
        <ReferenceField
          source='courtId'
          reference='courts'
          formClassName={classes.inline}>
          <TextField source='name' formClassName={classes.inline} />
        </ReferenceField>
        <NumberInput
          source='price'
          formClassName={classes.inline}
          validate={required()}
        />
        <CheckboxGroupInput
          formClassName={classes.margin}
          source='weekDays'
          choices={[
            {id: '0', name: 'Sunday'},
            {id: '1', name: 'Monday'},
            {id: '2', name: 'Tuesday'},
            {id: '3', name: 'Wednesday'},
            {id: '4', name: 'Thursday'},
            {id: '5', name: 'Friday'},
            {id: '6', name: 'Saturday'},
          ]}
        />
        <TimeInput
          source='from'
          name='from'
          formClassName={classes.inline}
          validate={required()}
        />
        <TimeInput
          source='to'
          name='to'
          formClassName={classes.inline}
          validate={required()}
        />
      </SimpleForm>
    </Create>
  );
};

export default PriceCreate;
